import React, { useEffect, useState } from 'react'
import SideDrawer from '../../../../Components/sideDrower/SideDrawer';
import useDebounce from '../../../../hooks/useDebounce';
import { CiSearch } from 'react-icons/ci';
import { avatar } from '../../../../assets';
import { Dropdown } from 'react-bootstrap';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { feedRequestListApi, updateFeedRequestApi } from '../../../../services/feeds';
import { toastMessage } from '../../../../utils/toastMessage';
import { LoadingButton } from '../../../../Components/header/form';

const FeedRequest = ({ show, close, groupId, listing = () => { }, setPage, setHasMore }) => {
    const [search, setSearch] = useState('')
    const debouncedValue = useDebounce(search, 300);
    const { showAuth } = useSelector((state) => state?.showAuth);
    const [feedList, setFeedList] = useState([]);
    const [loaders, setLoaders] = useState({ accepted: false, rejected: false });
    const [loading, setLoading] = useState({ accepted: false, rejected: false });
    // console.log('feedList', feedList)

    //------------handle-status----------------------
    const statusHandler = async (item, status) => {
        try {
            let payload = {
                _id: item?._id,
                status: status,
            };
            if (status === 'ACCEPT') {
                setLoaders({ accepted: true, rejected: false })
            } else {
                setLoaders({ accepted: false, rejected: true })
            }
            const { data } = await updateFeedRequestApi(payload);
            const { success, message, data: response } = data;
            if (success) {
                getFeedListHandler()
                if (status === 'ACCEPT') {
                    setPage(1)
                    setHasMore(true)
                    setTimeout(() => {
                        listing(1, true);
                    }, 1000);
                }
            }
            toastMessage(message, success ? 'success' : "error", "joinHandler");
        } catch (e) {
            console.log("Error:-", e.message);
        } finally {
            setLoaders({ accepted: false, rejected: false })
        }
    };
    //----------request-list------------
    const getFeedListHandler = async () => {
        try {
            setLoading(true)
            const { data } = await feedRequestListApi({
                pagination: true,
                page: 1,
                limit: 1000,
                _group: groupId,
                search: debouncedValue
            });
            const { success, message, data: response } = data;
            if (success) {
                setFeedList(response);
            } else {
                toastMessage(message, "error", "feedList");
            }
        } catch (e) {
            console.log("Error:-", e.message);
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        getFeedListHandler();
    }, [debouncedValue, show]);
    return (
        <>
            <SideDrawer
                className="all_member_head"
                show={show}
                handleClose={close}
            >
                <h3 className="drawer_title">    Feed Request</h3>

                <div className="tabber">
                    <div className="search_group">
                        <CiSearch />
                        <input onChange={(e) => setSearch(e.target.value)} type="text" className="search_bar" placeholder="Search" />
                    </div>
                    {
                        loading ? (
                            <h5 className="text-center mt-4">Loading...</h5>
                        ) : (
                            <div className="new_request_parent">
                                {feedList && feedList.length > 0 ? feedList?.map((data, ind) => (
                                    <ul key={ind} className="new_requset_wraper">
                                        <li className="rqt_join_grpes">
                                            <img
                                                src={data?.attachments?.[0]?.url || avatar}
                                                alt="Request_first"
                                            />

                                            <div className="rqt_join_content">
                                                <p className="text">
                                                    <b className="name">{data?.title}</b> has
                                                    requested to join your group.
                                                </p>

                                                <div className="acceot_btn_wraper">
                                                    <LoadingButton
                                                        loading={loaders?.rejected}
                                                        onClick={() => statusHandler(data, 'REJECT')}
                                                        className="reject_btn"
                                                        type="button"
                                                    >
                                                        Reject
                                                    </LoadingButton>
                                                    <LoadingButton
                                                        loading={loaders?.accepted}
                                                        onClick={() => statusHandler(data, 'ACCEPT')}
                                                        className="accept_btn" type="button"
                                                    >
                                                        Accept
                                                    </LoadingButton>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                )) : <h5 className="text-center mt-4">No Request Found</h5>}
                            </div>
                        )
                    }
                </div>
            </SideDrawer>

        </>
    )
}

export default FeedRequest